module.exports = __webpack_public_path__ + "img/loma.3f38cff3.jpg";